import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from "@material-ui/core/Checkbox";
import styled from "@emotion/styled";

const ColumnHeadingsWrapper = styled.div`
    display: grid;
    
    grid-template-columns: ${ props =>
        props.gridTemplate
            ? props.gridTemplate
            :`repeat(${props.columnCount}, 150px)`
    };
    grid-auto-flow: column;    
`;

const ColumnHeading = styled.h4`
  font-size: var(--font-m);
  font-weight: 500;
  display: flex;
  align-items: center;

  &:first-of-type {
    grid-column-start: 1;
  }
`;

function SidePanelTableHeadingComponent(props) {
    const {tableHeadings, hasCheckBox, isChecked, onCheckBoxClicked, indeterminate, gridTemplate} = props;
    return (
        <ColumnHeadingsWrapper
            columnCount={tableHeadings.length}
            gridTemplate={gridTemplate}
        >
            {
                tableHeadings.length
                    ?
                    <>
                        {tableHeadings.slice(0, 1).map(firstHeading =>
                            <ColumnHeading
                                hasIndent={!hasCheckBox}
                                key={firstHeading.name}>
                                {
                                    hasCheckBox
                                    && <Checkbox
                                        indeterminate={indeterminate}
                                        value={"tableHeading"}
                                        checked={isChecked}
                                        onChange={onCheckBoxClicked}
                                        color="primary"
                                        inputProps={{
                                            'aria-label': 'primary checkbox',
                                        }}/>
                                }
                                {firstHeading.name}
                            </ColumnHeading>)}

                        {tableHeadings.slice(1).map(heading => <ColumnHeading
                            key={heading.name}>{heading.name}</ColumnHeading>)}
                    </>
                    : null
            }
        </ColumnHeadingsWrapper>
    );
}

SidePanelTableHeadingComponent.propTypes = {};
SidePanelTableHeadingComponent.defaultProps = {};

export default SidePanelTableHeadingComponent;
